import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
	rus: (
		`
		<div style="text-align: justify;">
		
			<p class="mb-3">
				Тело дёрнулось несколько раз, и затихло.
			</p>
			
			<p class="mb-3">
				И никто не заметил, как из него вышла невидимая световая стрелка и унеслась ввысь.
			</p>
			
			<p class="mb-3">
				Я двигался в разлитом везде свете. 
				Вокруг не было ничего, кроме прозрачного сияния, и я растворился в нём, стал частью его, свободно паря в невесомости.
			</p>
			
			<p class="mb-3">
				Но вот я вдруг снова обрёл форму, отделился от окружающего и свободно стал падать вниз. 
				Вниз, сквозь тьму, сначала чёрную, потом багровую, густую, плотно облепляющую меня. 
				Я извивался в её извивах, вонзаясь всё дальше, всё глубже вниз.
			</p>
			
			<p class="mb-3">
				Я потерял свою форму, все чувства и ощущения, стал ничем, только потенцией, спиралью, которая будет раскрываться потом, в течение жизни. 
			</p>
			
			<p class="mb-3">
				И вот – снова свет.
			</p>
			
			<p class="mb-3">
				Человек родился!
			</p>
			
		</div>
		`
	)
}

const itemName = {
	rus: `Тело дернулось несколько раз`
}

const itemDate = {
	rus: `24 февраля 2026`
}

const item = {
	itemlink: getLink(itemName.rus),
	rus: {
		itemName: itemName.rus,
		itemDate: itemDate.rus,
		itemContent: content.rus,
		itemAuthor: author.rus
	}
}

export default item;